import { Box } from "@mui/material";
import React, { useState } from "react";

// call page
import { Navigate } from "react-router-dom";
// import HumanResourceMenu from "./HumanResourceMenu";
import Employee from "../features/humanresource/employee/Form";
import ProjectMaster from "../features/humanresource/project/ProjectForm";
import SalaryStructure from "../features/humanresource/salarystructure/StructureForm";
import EmployeeAttendance from "../features/humanresource/attendance/AttendanceForm";
import LeaveRequestForm from "../features/humanresource/leaverequest/LeaveRequestForm";
import LeaveApprovalDashboard from "../features/humanresource/leaverequest/LeaveApprovalDashboard";
import AddOvertime from "../features/humanresource/overtime/AddOvertime";
import ViewOvertime from "../features/humanresource/overtime/ViewOvertime";
import ShiftMasterForm from "../features/humanresource/shift-master/ShiftMasterForm";
import ShiftRoasterForm from "../features/humanresource/roaster/ShiftRoasterForm";
import ShiftEmployeeAssignmentForm from "../features/humanresource/assignment/ShiftAssignment";
import LeaveBalanceForm from "../features/humanresource/leavebalance/LeaveBalanceForm";
import SalarySlip from "../features/humanresource/salaryslip/SalarySlipForm";
import HumanResourceMenu from "../features/humanresource/human-resource-menu";
import HolidaysList from "../features/humanresource/holidays/HolidaysList";
import EmployeeWeekOffs from "../features/humanresource/employeeweekoff/EmployeeWeekOffs";
import ShiftWeekOffScheduler from "../features/humanresource/roaster/ShiftWeekOffScheduler";
import ShiftRosterUI from "../features/humanresource/shift-master/ShiftRoasterUI";
import AddUpdateOnDutyTravelExpense from "../features/humanresource/ondutyreimpursement/AddUpdateOnDutyTravelExpense";
import OnDutyIndex from "../features/humanresource/ondutyreimpursement/OnDutyIndex";
import OnDutyApprovalIndex from "../features/humanresource/reimpursementapproval/OnDutyApprovalIndex";
const HumanResource = () => {

    const [activePage, setActivePage] = useState('ViewMainPage');
    const SetActive = (page) => {
        setActivePage(page);
    }
    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');
    }
    const handleBackDashboard = () => {
        Navigate("/");
    }

    return (

        <Box position="relative">

            {activePage === "ViewMainPage" && (<HumanResourceMenu
                SetActive={SetActive} handleBackDashboard={handleBackDashboard}
            />)}

            {activePage === "ViewEmployeeListPage" && (
                <Employee handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewProjectList" && (
                <ProjectMaster handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "AttendanceOverview" && (
                <EmployeeAttendance handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewSalaryComponents" && (
                <SalaryStructure handleBackWinderMachineEntry={handleBackWinderMachineEntry} />

            )}

            {activePage === "LeaveApprovalDashboard" && (
                <LeaveApprovalDashboard handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "LeaveRequestForm" && (
                <LeaveRequestForm handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "LeaveBalance" && (
                <LeaveBalanceForm handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "OvertimeApprovalDashboard" && (
                <ViewOvertime handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
            {activePage === "AddOvertime" && (
                <AddOvertime handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ShiftMaster" && (
                <ShiftMasterForm handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ShiftRoaster" && (
                <ShiftRoasterForm handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ShiftEmployeeAssignment" && (
                <ShiftEmployeeAssignmentForm handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

            {activePage === "ViewSalarySlip" && (
                <SalarySlip handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
{/* 
            {activePage === "ViewHolidays" && (
                <HolidaysList handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )} */}

            {activePage === "ViewHolidays" && (
                <EmployeeWeekOffs />
            )}
 {activePage === "Shift Weekly Off Assignment" && (
                <ShiftWeekOffScheduler />
            )}
 {activePage === "Shift Roaster UI" && (
                <ShiftRosterUI />
            )}
             {activePage === "OnDuty Reimpursement" && (
                // <AddUpdateOnDutyTravelExpense handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
                 <OnDutyIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}
{activePage === "OnDuty Approval" && (
                // <AddUpdateOnDutyTravelExpense handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
                 <OnDutyApprovalIndex handleBackWinderMachineEntry={handleBackWinderMachineEntry} />
            )}

        </Box>
    );
};
export default HumanResource;